import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { UpdateHostClassService } from '../core/update-host-class.service';

@Directive({
  selector: '[jd-form]'
})
export class JdFormDirective implements OnInit {
  el: HTMLElement;
  prefixCls = 'ant-form';
  private _layout = 'horizontal';

  @Input()
  set jdLayout(value: string) {
    this._layout = value;
    this.setClassMap();
  }

  get jdLayout(): string {
    return this._layout;
  }

  setClassMap(): void {
    const classMap = {
      [`${this.prefixCls}`]: true,
      [`${this.prefixCls}-${this.jdLayout}`]: this.jdLayout
    };
    this.jdUpdateHostClassService.updateHostClass(this.el, classMap);
  }

  constructor(
    private elementRef: ElementRef,
    // private renderer: Renderer2,
    private jdUpdateHostClassService: UpdateHostClassService
  ) {
    // console.log(renderer);
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit(): void {
    this.setClassMap();
  }
}
